import { getLocale } from "../runtime";

const sv_brands = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Varumärken`
};

const brands = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_brands(inputs)
	return "brands";
};

export { brands as "brands" };